import React from 'react';

import { Link } from '@simplybusiness/mobius-simplybusiness';

const CustomerServiceContact = () => (
  <>
    <>Please call:&nbsp;</>
    <Link href="tel:03330146683">0333 014 6683</Link>
  </>
);

export default CustomerServiceContact;
